import { render } from "./ShareConsentCheckbox.vue?vue&type=template&id=155606ba"
import script from "./ShareConsentCheckbox.vue?vue&type=script&lang=js"
export * from "./ShareConsentCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__